module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Food/Miso-soup-c3cb1a9b8d4575c704c521f538d29a3f.svg";